{
  "translation": {
    "aboutMirador": "A Mirador Project weboldala",
    "aboutThisItem": "Elem adatai",
    "addedFromUrl": "(URL-ként hozzáadva)",
    "addManifestUrl": "Manifest URL",
    "addManifestUrlHelp": "Az IIIF-dokumentum hivatkozása",
    "addResource": "Hozzáadás",
    "annotationCanvasLabel_1/1": "Elem: [{{label}}]",
    "annotationCanvasLabel_1/2": "Balra: [{{label}}]",
    "annotationCanvasLabel_2/2": "Jobbra: [{{label}}]",
    "annotations": "Megjegyzések",
    "attribution": "Tulajdon",
    "attributionTitle": "Szerzői jogok",
    "authenticationFailed": "Sikertelen bejelentkezés",
    "authenticationRequired": "A teljes eléréshez bejelentkezés szükséges",
    "backToResults": "Vissza a találatokhoz",
    "book": "Könyv",
    "bottom": "Lent",
    "cancel": "Mégsem",
    "canvasIndex": "Index",
    "changeTheme": "Téma módosítása",
    "clearSearch": "törlés",
    "close": "Bezárás",
    "closeAddResourceForm": "Bezárás",
    "closeAddResourceMenu": "Lista bezárása",
    "closeCompanionWindow": "Panel bezárása",
    "closeWindow": "Ablak bezárása",
    "collapseSection": "\"{{section}}\" rész bezárása",
    "collapseSidePanel": "Oldalsáv elrejtése",
    "collection": "Gyűjtemény",
    "continue": "Folytatás",
    "copy": "Másolás",
    "currentItem": "Aktuális elem",
    "currentItem_1/1": "Aktuális elem",
    "currentItem_1/2": "Balra",
    "currentItem_2/2": "Jobbra",
    "dark": "Sötét téma",
    "digitizedView": "Digitalizált nézet",
    "dismiss": "Bezár",
    "displayNoAnnotations": "Annotációk elrejtése",
    "downloadExport": "Munkaterület exportálása",
    "downloadExportWorkspace": "Munkaterület exportálása",
    "elastic": "Elastic",
    "elasticDescription": "Szabadon mozgathatja az ablakokat, akár fedhetik is egymást.",
    "emptyResourceList": "A forráslista üres",
    "error": "Hiba",
    "errorDialogConfirm": "OK",
    "errorDialogTitle": "Hiba történt",
    "exitFullScreen": "Teljes képernyő bezárása",
    "expandSection": "\"{{section}}\" rész kinyitása",
    "expandSidePanel": "Oldalsáv kinyitása",
    "exportCopied": "Munkaterület beállításai vágólapra másolva",
    "fetchManifest": "Hozzáadás",
    "fullScreen": "Teljes képernyő",
    "gallery": "Galéria",
    "hideZoomControls": "Zoom eszközök elrejtése",
    "highlightAllAnnotations": "Annotációk megjelenítése",
    "iiif_homepage": "Dokumentum adatai",
    "iiif_manifest": "IIIF manifest",
    "iiif_related": "Kapcsolódó",
    "iiif_renderings": "Más formátumok",
    "iiif_seeAlso": "Lásd még",
    "import": "Importálás",
    "importWorkspace": "Munkaterület importálása",
    "importWorkspaceHint": "Illesszen be egy Mirador 4 konfigurációt",
    "item": "Elem: {{label}}",
    "itemList": "Tartalomjegyzék",
    "jsError": "Technikai adatok",
    "jsStack": "{{ stack }}",
    "language": "Nyelv",
    "layer_hide": "Réteg elrejtése",
    "layer_move": "Réteg mozgatása",
    "layer_moveToBackground": "Réteg mozgatása hátra",
    "layer_moveToFront": "Réteg mozgatása előre",
    "layer_opacity": "Réteg átlátszósága",
    "layer_show": "Réteg megjelenítése",
    "layers": "Rétegek",
    "light": "Világos téma",
    "links": "Linkek",
    "listAllOpenWindows": "Ablakok",
    "login": "Bejelentkezés",
    "logout": "Kijelentkezés",
    "manifestError": "Nem sikerült a hozzáadás:",
    "maximizeWindow": "Teljes méretű ablak",
    "minimizeWindow": "Előző méret",
    "mirador": "Mirador",
    "miradorResources": "Mirador dokumentumok",
    "miradorViewer": "Mirador viewer",
    "more": "több...",
    "moreResults": "További találatok",
    "mosaic": "Mozaik",
    "mosaicDescription": "Ablakok mozgatása és átméretezése megadott területen.",
    "moveCompanionWindowToBottom": "Mozgatás lefelé",
    "moveCompanionWindowToRight": "Mozgatás jobbra",
    "multipartCollection": "Összetett gyűjtemény",
    "nextCanvas": "Következő",
    "noItemSelected": "Nincs kiválasztott elem",
    "numItems_one": "{{number}} elem",
    "numItems_other": "{{number}} elem",
    "off": "Nincs",
    "openCompanionWindow_annotations": "Megjegyzések",
    "openCompanionWindow_attribution": "Szerzői jogok",
    "openCompanionWindow_canvas": "Tartalomjegyzék",
    "openCompanionWindow_info": "Információ",
    "openCompanionWindow_layers": "Rétegek",
    "openCompanionWindow_search": "Keresés",
    "openInCompanionWindow": "Megnyitás új panelen",
    "openWindows": "Megnyitott ablakok",
    "pagination": "{{current}} / {{total}}",
    "position": "Pozíció",
    "previewWindowTitle": "{{title}}",
    "previousCanvas": "Előző",
    "related": "Kapcsolódó",
    "resource": "Adatok",
    "retry": "Űjra",
    "right": "Jobbra",
    "rights": "Licensz",
    "scroll": "Görgetés",
    "searchInputLabel": "kereső szavak",
    "searchNextResult": "Következő találat",
    "searchNoResults": "Nincs találat",
    "searchPreviousResult": "Előző találat",
    "searchResultsRemaining": "{{numLeft}} van hátra",
    "searchSubmitAria": "Keresés",
    "searchTitle": "Keresés",
    "selectWorkspaceMenu": "Munkaterület típusának kiválasztása",
    "showCollection": "Gyűjtemény megjelenítése",
    "showingNumAnnotations_one": "{{number}} megjegyzés megjelenítve",
    "showingNumAnnotations_other": "{{number}} megjegyzés megjelenítve",
    "showZoomControls": "Zoom eszközök megjelenítése",
    "sidebarPanelsNavigation": "Oldalsáv navigáció",
    "single": "Egyoldalas",
    "startHere": "Hozzáadás",
    "suggestSearch": "Keresés: \"{{ query }}\"",
    "tableOfContentsList": "Tartalomjegyzék",
    "theme": "Téma",
    "thumbnailList": "Előnézeti képek listája",
    "thumbnailNavigation": "Előnézeti képek",
    "thumbnails": "Előnézeti képek",
    "toggleWindowSideBar": "Oldalsáv ki/bekapcsolása",
    "totalCollections_one": "{{count}} gyűjtemény",
    "totalCollections_other": "{{count}} gyűjtemény",
    "totalManifests_one": "{{count}} manifest",
    "totalManifests_other": "{{count}} manifest",
    "tryAgain": "Próbálja újra",
    "untitled": "[Névtelen]",
    "view": "Megtekintés",
    "viewWorkspaceConfiguration": "Munkaterület beállítások",
    "welcome": "Üdvözli a Mirador",
    "window": "Ablak: {{label}}",
    "windowMenu": "Megjelenítési mód & előnézet",
    "windowNavigation": "Ablakok kezelése",
    "windowPluginButtons": "Beállítások",
    "windowPluginMenu": "További lehetőségek",
    "workspace": "Munkaterület",
    "workspaceFullScreen": "Teljes képernyő",
    "workspaceMenu": "Munkaterület beállítások",
    "workspaceNavigation": "Workspace navigation",
    "workspaceOptions": "Munkaterület lehetőségek",
    "workspaceSelectionTitle": "Munkaterület típusa",
    "zoomIn": "Nagyítás",
    "zoomOut": "Kicsinyítés",
    "zoomReset": "Képméret ablakhoz igazítása"
  }
}
